import { z } from 'zod';
import { emailSchema } from '../auth/email.js';

export const updateInstitutionUserSchema = z.object({
  first_name: z.string().min(1, 'First name is required'),
  last_name: z.string().min(1, 'Last name is required'),
  email: emailSchema('Valid email is required'),
  phone: z.string().optional(),
});

export type UpdateInstitutionUserPayload = z.infer<typeof updateInstitutionUserSchema>;
